import { Form, Input } from "antd";
import React, { lazy, Suspense, useState } from "react";
import { useSelector } from "react-redux";
import { $t } from "~/i18n.js";

import { DataCard } from "~/components/dataCards/dataCard.jsx";
import { CountryCodeSelect } from "~/components/form/CountryCodeSelect.jsx";
import { deserializePhone, serializePhone } from "~/lib/localize.js";

const UserMapEdit = lazy(() => import("~/components/userMap/UserMapEdit.jsx"));

export const CardContact = ({
  gegevens,
  profile,
  saveData,
  type,
  readOnly,
  onChange,
}) => {
  const club = useSelector((state) => state.persist.club);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [lat, setLat] = useState(gegevens?.lat || 0);
  const [lon, setLon] = useState(gegevens?.lon || 0);

  const getAddress = () =>
    form.getFieldsValue(["address1", "address2", "zipcode", "city", "country"]);

  const saveForm = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const res = await saveData({
        gegevens: { ...values, lat, lon },
        profile: { phone: serializePhone(values.phone) },
      });
      setLoading(false);
      return res;
    } catch (info) {
      console.log("Validate Failed:", info);
      setLoading(false);
    }
  };

  return (
    <DataCard
      title={$t("Contactgegevens")}
      onSave={!onChange && saveForm}
      loading={loading}
      type={type}
      id="contact"
    >
      <Form
        form={form}
        name="contact"
        initialValues={{
          ...gegevens,
          phone: deserializePhone(profile.phone),
        }}
        requiredMark={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 14 }}
        onValuesChange={
          onChange
            ? (_, values) => {
                onChange({
                  gegevens: { ...values, lat, lon },
                  profile: { phone: serializePhone(values.phone) },
                });
              }
            : undefined
        }
      >
        <Form.Item
          label={$t("Telefoon")}
          name="phone"
          rules={[{ required: true, message: $t("Wat is je telefoon") }]}
        >
          <Input type="tel" disabled={readOnly} />
        </Form.Item>

        <Form.Item
          label={$t("Adres")}
          name="address1"
          rules={[{ required: true, message: $t("Wat is je adres?") }]}
        >
          <Input disabled={readOnly} />
        </Form.Item>

        <Form.Item label={$t("Adres 2")} name="address2">
          <Input disabled={readOnly} />
        </Form.Item>

        <Form.Item
          label={$t("Postcode")}
          name="zipcode"
          rules={[{ required: true, message: $t("Wat is je post code?") }]}
        >
          <Input disabled={readOnly} />
        </Form.Item>

        <Form.Item
          label={$t("Stad")}
          name="city"
          rules={[{ required: true, message: $t("In welke stad woon je?") }]}
        >
          <Input disabled={readOnly} />
        </Form.Item>

        <Form.Item
          label={$t("Land")}
          name="country"
          rules={[{ required: true, message: $t("In welk land woon je?") }]}
        >
          <CountryCodeSelect clubCountry={club?.country} disabled={readOnly} />
        </Form.Item>

        <Form.Item label={$t("Locatie")} wrapperCol={{ span: 16 }}>
          <Suspense fallback={null}>
            <UserMapEdit
              lat={lat}
              lon={lon}
              onLocationChange={(newLat, newLon) => {
                setLat(newLat);
                setLon(newLon);
                if (onChange) {
                  onChange({
                    gegevens: {
                      ...form.getFieldsValue(),
                      lat: newLat,
                      lon: newLon,
                    },
                    profile: {
                      phone: serializePhone(form.getFieldValue("phone")),
                    },
                  });
                }
              }}
              readOnly={readOnly}
              getAddress={getAddress}
            />
          </Suspense>
        </Form.Item>
      </Form>
    </DataCard>
  );
};
